import { render } from "./SectionHero.vue?vue&type=template&id=33c4b838"
import script from "./SectionHero.vue?vue&type=script&lang=js"
export * from "./SectionHero.vue?vue&type=script&lang=js"

import "./SectionHero.vue?vue&type=style&index=0&id=33c4b838&lang=css"

import exportComponent from "E:\\aaes\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__